import React from "react";
import "./footer.css";

const quickLinks01 = [
  {
    path: "#service",
    display: "DEV web & mobile",
  },
  {
    path: "#service",
    display: "Ergonomie et design",
  },
  {
    path: "#service",
    display: "Formation",
  },
];
const quickLinks02 = [
  {
    path: "#blog",
    display: "Videos",
  },
  {
    path: "#blog",
    display: "Article",
  },
  {
    path: "#blog",
    display: "Etude de cas",
  },
];
const quickLinks03 = [
  {
    path: "#about",
    display: "Apropos",
  },
  {
    path: "#team",
    display: "Nous rejoindre",
  },
  {
    path: "#blog",
    display: "Blog",
  },
];

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer__wrapper">
          <div className="footer__logo">
            <h2>IDA VISION</h2>
            <p className="description">
              {/* Grandissons ensemble */}
              Le digital au Service d'une vision de qualité
            </p>
            <p className="small__text description">
              {/* © 2020 - Tous droits réservés */}
              Pour un partenaire statégique, efficace et créatif, contactez-nous
              et nous ferons un plaisir de vous aider.
            </p>
          </div>

          <div className="footer__quick-links">
            <h3 className="quick__links-title">Solutions</h3>
            <ul className="quick__links">
              {quickLinks01.map((item, index) => (
                <li className="quick__link-item" key={index}>
                  <a href={item.path}>{item.display}</a>
                </li>
              ))}
            </ul>
          </div>

          <div className="footer__quick-links">
            <h3 className="quick__links-title">Support</h3>
            <ul className="quick__links">
              {quickLinks02.map((item, index) => (
                <li className="quick__link-item" key={index}>
                  <a href={item.path}>{item.display}</a>
                </li>
              ))}
            </ul>
          </div>

          <div className="footer__quick-links">
            <h3 className="quick__links-title">L'entreprise</h3>
            <ul className="quick__links">
              {quickLinks03.map((item, index) => (
                <li className="quick__link-item" key={index}>
                  <a href={item.path}>{item.display}</a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <p className="copyright">
          © Copyright {year}, developpé par ida vision Tous droits réservés{" "}
        </p>
      </div>
    </footer>
  );
};

export default Footer;
